
import React, {FC, useEffect} from 'react';
import {Modal} from 'react-bootstrap';
import {ModalProps} from 'utils/types/modal';
import {hsForm, parseDefaults} from 'utils/window/hubspot';

import * as styles from './styles.module.scss';

export const HubSpotForm = (formId?: string, defaults?: string): FC<ModalProps> => {
	if (!formId) {
		return () => null;
	}

	const target = 'hs' + formId.substring(0, 8);
	const Component: FC<ModalProps> = ({show, onClose}) => {
		useEffect(() => {
			if (show) {
				hsForm.init(
					formId,
					target,
					parseDefaults(defaults),
				);
			}
		}, [show]);

		return (
			<Modal contentClassName={styles.modal} size='lg' show={show} onHide={onClose}>
				<Modal.Header closeButton onHide={onClose} />
				<Modal.Body className={styles.body}>
					<div id={target} className={styles.form} />
				</Modal.Body>
			</Modal>
		);
	};

	return Component;
};

export default HubSpotForm;
